/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.RequestMsg = (function() {

    /**
     * Properties of a RequestMsg.
     * @exports IRequestMsg
     * @interface IRequestMsg
     * @property {string|null} [guid] RequestMsg guid
     * @property {number|null} [version] RequestMsg version
     * @property {string|null} [fromGuid] RequestMsg fromGuid
     * @property {string|null} [targetGuid] RequestMsg targetGuid
     * @property {RequestMsg.RequestType|null} [requestType] RequestMsg requestType
     * @property {Array.<string>|null} [friends] RequestMsg friends
     */

    /**
     * Constructs a new RequestMsg.
     * @exports RequestMsg
     * @classdesc Represents a RequestMsg.
     * @implements IRequestMsg
     * @constructor
     * @param {IRequestMsg=} [properties] Properties to set
     */
    function RequestMsg(properties) {
        this.friends = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RequestMsg guid.
     * @member {string} guid
     * @memberof RequestMsg
     * @instance
     */
    RequestMsg.prototype.guid = "";

    /**
     * RequestMsg version.
     * @member {number} version
     * @memberof RequestMsg
     * @instance
     */
    RequestMsg.prototype.version = 0;

    /**
     * RequestMsg fromGuid.
     * @member {string} fromGuid
     * @memberof RequestMsg
     * @instance
     */
    RequestMsg.prototype.fromGuid = "";

    /**
     * RequestMsg targetGuid.
     * @member {string} targetGuid
     * @memberof RequestMsg
     * @instance
     */
    RequestMsg.prototype.targetGuid = "";

    /**
     * RequestMsg requestType.
     * @member {RequestMsg.RequestType} requestType
     * @memberof RequestMsg
     * @instance
     */
    RequestMsg.prototype.requestType = 0;

    /**
     * RequestMsg friends.
     * @member {Array.<string>} friends
     * @memberof RequestMsg
     * @instance
     */
    RequestMsg.prototype.friends = $util.emptyArray;

    /**
     * Creates a new RequestMsg instance using the specified properties.
     * @function create
     * @memberof RequestMsg
     * @static
     * @param {IRequestMsg=} [properties] Properties to set
     * @returns {RequestMsg} RequestMsg instance
     */
    RequestMsg.create = function create(properties) {
        return new RequestMsg(properties);
    };

    /**
     * Encodes the specified RequestMsg message. Does not implicitly {@link RequestMsg.verify|verify} messages.
     * @function encode
     * @memberof RequestMsg
     * @static
     * @param {IRequestMsg} message RequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromGuid);
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.targetGuid);
        if (message.requestType != null && message.hasOwnProperty("requestType"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.requestType);
        if (message.friends != null && message.friends.length)
            for (var i = 0; i < message.friends.length; ++i)
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.friends[i]);
        return writer;
    };

    /**
     * Encodes the specified RequestMsg message, length delimited. Does not implicitly {@link RequestMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RequestMsg
     * @static
     * @param {IRequestMsg} message RequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RequestMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof RequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RequestMsg} RequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RequestMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RequestMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.fromGuid = reader.string();
                break;
            case 4:
                message.targetGuid = reader.string();
                break;
            case 5:
                message.requestType = reader.int32();
                break;
            case 6:
                if (!(message.friends && message.friends.length))
                    message.friends = [];
                message.friends.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a RequestMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RequestMsg} RequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RequestMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RequestMsg message.
     * @function verify
     * @memberof RequestMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RequestMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            if (!$util.isString(message.targetGuid))
                return "targetGuid: string expected";
        if (message.requestType != null && message.hasOwnProperty("requestType"))
            switch (message.requestType) {
            default:
                return "requestType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 9:
                break;
            }
        if (message.friends != null && message.hasOwnProperty("friends")) {
            if (!Array.isArray(message.friends))
                return "friends: array expected";
            for (var i = 0; i < message.friends.length; ++i)
                if (!$util.isString(message.friends[i]))
                    return "friends: string[] expected";
        }
        return null;
    };

    /**
     * Creates a RequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RequestMsg} RequestMsg
     */
    RequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.RequestMsg)
            return object;
        var message = new $root.RequestMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        if (object.targetGuid != null)
            message.targetGuid = String(object.targetGuid);
        switch (object.requestType) {
        case "UNKNOWN":
        case 0:
            message.requestType = 0;
            break;
        case "GUID":
        case 1:
            message.requestType = 1;
            break;
        case "UNREAD":
        case 2:
            message.requestType = 2;
            break;
        case "CLEAR_UNREAD":
        case 3:
            message.requestType = 3;
            break;
        case "PULL_LASTMSG":
        case 4:
            message.requestType = 4;
            break;
        case "SYNC_FRIENDS":
        case 9:
            message.requestType = 9;
            break;
        }
        if (object.friends) {
            if (!Array.isArray(object.friends))
                throw TypeError(".RequestMsg.friends: array expected");
            message.friends = [];
            for (var i = 0; i < object.friends.length; ++i)
                message.friends[i] = String(object.friends[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a RequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RequestMsg
     * @static
     * @param {RequestMsg} message RequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.friends = [];
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.fromGuid = "";
            object.targetGuid = "";
            object.requestType = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            object.targetGuid = message.targetGuid;
        if (message.requestType != null && message.hasOwnProperty("requestType"))
            object.requestType = options.enums === String ? $root.RequestMsg.RequestType[message.requestType] : message.requestType;
        if (message.friends && message.friends.length) {
            object.friends = [];
            for (var j = 0; j < message.friends.length; ++j)
                object.friends[j] = message.friends[j];
        }
        return object;
    };

    /**
     * Converts this RequestMsg to JSON.
     * @function toJSON
     * @memberof RequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * RequestType enum.
     * @name RequestMsg.RequestType
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} GUID=1 GUID value
     * @property {number} UNREAD=2 UNREAD value
     * @property {number} CLEAR_UNREAD=3 CLEAR_UNREAD value
     * @property {number} PULL_LASTMSG=4 PULL_LASTMSG value
     * @property {number} SYNC_FRIENDS=9 SYNC_FRIENDS value
     */
    RequestMsg.RequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "GUID"] = 1;
        values[valuesById[2] = "UNREAD"] = 2;
        values[valuesById[3] = "CLEAR_UNREAD"] = 3;
        values[valuesById[4] = "PULL_LASTMSG"] = 4;
        values[valuesById[9] = "SYNC_FRIENDS"] = 9;
        return values;
    })();

    return RequestMsg;
})();

module.exports = $root;
